{
  "alert": "Avviso",
  "dismiss": "Ignora"
}